<template>
  <!-- 关于我们-合作伙伴页面 -->
  <div id="app-partner">
    <pub-head></pub-head>
    <pubs-nav></pubs-nav>
    <div class="nav-top">
      <div class="top-box">
        <h3>合作伙伴</h3>
        <p>Partner</p>
      </div>
    </div>
    <div class="partner-box">
      <p>未来，爱眼公益将与更多的中国、国际优秀的公益组织展开合作，联合社会各界以及爱心人士，通过资助救治眼病患</p>
      <p>者来提升国民的眼健康水平;通过公益筛查和防盲教育来呼吁全社会对眼健康的关注。</p>
      <ul>
        <li v-for="(item,index) in orgList" :key="index" @click="goLink(item.link_url)">
          <img :src="item.logo_url" :alt="item.org_name" :title="item.org_name" />
        </li>
      </ul>
    </div>
    <pub-foot></pub-foot>
  </div>
</template>
<script>
import pubHead from "../Public/head";
import pubsNav from "../Public/nav";
import pubFoot from "../Public/foot";
export default {
  components: {
    pubHead,
    pubsNav,
    pubFoot
  },
  data() {
    return {
      orgList: []
    };
  },
  methods: {
    getOrgList() {
      this.$db
        .post(this.$db.config.getOrgListUrl, { org_type: 1 })
        .then(res => {
          if (res.code == 200) {
            this.orgList = res.data;
          }
        });
    },
    goLink(url) {
      if (url && url != "") {
        window.open(url);
      }
    }
  },
  created() {
    this.getOrgList();
  }
};
</script>

<style lang="scss" scoped>
#app-partner {
  width: 100%;
}
.nav-top {
  width: 100%;
  height: 300px;
  background: url(../../assets/images/nav_bg.png) no-repeat;
  background-size: 100% 100%;
  margin-bottom: 40px;
  .top-box {
    width: 1300px;
    margin: 0 auto;
    padding-top: 118px;
    > h3 {
      font-size: 36px;
      color: #333333;
      font-weight: normal;
    }
    > p {
      font-size: 26px;
      font-weight: normal;
      color: #999999;
    }
  }
}

.partner-box {
  width: 1300px;
  margin: 0 auto;
  padding-bottom: 100px;
  > p {
    font-size: 16px;
    line-height: 30px;
    color: #000000;
    text-align: center;
  }
  > ul {
    margin-top: 75px;
    display: flex;
    flex-wrap: wrap;
    > li {
      list-style: none;
      width: 200px;
      height: 60px;
      margin-bottom: 70px;
      margin-right: 16px;
      background-color: #ffffff;
      transition: ease-out 0.6s;
      cursor: pointer;
      &:hover {
        box-shadow: 0px 7px 20px 0px rgba(9, 1, 4, 0.14);
        transition: all 1.5s;
      }
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/public_partner.vue